import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:9080";

const client = axios.create({ baseURL: API_BASE_URL });

/** 회원 전용 API 호출 시 Authorization 헤더를 붙여준다. accessToken 이 없으면 빈 헤더. */
export function authHeader(accessToken) {
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
}

export default client;
